import { translateError } from "../../lib/errors";
import { useState } from "react";
import { supabase } from "../../lib/supabase";
import { AuthAlert, AuthShell, Field } from "../../components/auth/AuthShell";
import { Spinner } from "../../components/ui/Loader";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
        redirectTo: `${window.location.origin}/reset`,
      });
      if (error) {
        setError(translateError(error));
      } else {
        setSent(true);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      title="Відновлення паролю"
      subtitle="На email буде надіслано посилання для скидання паролю"
    >
      {sent ? (
        <AuthAlert
          kind="info"
          message="Якщо акаунт з таким email існує, ми надіслали лист із посиланням для відновлення паролю."
        />
      ) : (
        <form onSubmit={handleSubmit} className="mt-7 flex flex-col gap-4">
          <Field
            label="Email"
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
          {error && <AuthAlert kind="error" message={error} />}
          <button
            type="submit"
            disabled={submitting}
            className="btn-brand mt-2 w-full justify-center disabled:opacity-70"
          >
            {submitting ? (
              <>
                <Spinner className="h-4 w-4" />
                Зачекайте…
              </>
            ) : (
              "Надіслати посилання"
            )}
          </button>
        </form>
      )}
    </AuthShell>
  );
};
